import { CallStats, StatsCommon } from '#common/stats';
export class KeyRangeLockingStats extends StatsCommon {
    lock;
    unlockRange;
    unlockAllHeldByNode;
    constructor(log) {
        super();
        this.lock = new CallStats('lock', log);
        this.unlockRange = new CallStats('unlockRange', log);
        this.unlockAllHeldByNode = new CallStats('unlockAllHeldByNode', log);
    }
}
